module.exports = __webpack_public_path__ + "img/49ea528.jpg";